import { render } from "./CardTitle.vue?vue&type=template&id=46809b52"
import script from "./CardTitle.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./CardTitle.vue?vue&type=script&charset=utf-8&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__